'use client'

import { useMemo } from 'react'
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts'
import { TOOLTIP_STYLE, AXIS_STYLE, CHART_COLORS } from './chartConfig'
import type { Task } from '@/types'

export default function FlowEffChart({ tasks }: { tasks: Task[] }) {
  const data = useMemo(() => {
    const byCat: Record<string, number[]> = {}
    tasks.forEach(t => {
      if (t.flow_eff === null) return
      if (!byCat[t.cat]) byCat[t.cat] = []
      byCat[t.cat].push(t.flow_eff)
    })
    return Object.entries(byCat)
      .sort(([a], [b]) => a.localeCompare(b))
      .map(([cat, vals]) => ({
        cat,
        avg: Math.round(vals.reduce((a, b) => a + b, 0) / vals.length),
      }))
  }, [tasks])

  return (
    <ResponsiveContainer width="100%" height={220}>
      <BarChart data={data} layout="vertical">
        <XAxis type="number" domain={[0, 100]} {...AXIS_STYLE} />
        <YAxis type="category" dataKey="cat" tick={{ fontSize: 13, fill: '#64748b' }} stroke="#cbd5e1" width={70} />
        <Tooltip {...TOOLTIP_STYLE} formatter={(val) => `${val}%`} />
        <Bar dataKey="avg" fill={CHART_COLORS.primary} radius={[0, 2, 2, 0]} name="Flow Efficiency %" />
      </BarChart>
    </ResponsiveContainer>
  )
}
